"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconService = void 0;
const core_1 = require("@angular/core");
let IconService = class IconService {
    constructor() {
        this.storageKey = 'webos-custom-icons';
        this.customIcons = (0, core_1.signal)({});
        this.loadFromStorage();
        (0, core_1.effect)(() => {
            this.saveToStorage(this.customIcons());
        });
    }
    loadFromStorage() {
        try {
            const storedIcons = localStorage.getItem(this.storageKey);
            if (storedIcons) {
                this.customIcons.set(JSON.parse(storedIcons));
            }
        }
        catch (e) {
            console.error('Failed to load custom icons from localStorage', e);
        }
    }
    saveToStorage(icons) {
        try {
            localStorage.setItem(this.storageKey, JSON.stringify(icons));
        }
        catch (e) {
            console.error('Failed to save custom icons to localStorage', e);
        }
    }
    setCustomIcon(appId, iconDataUrl) {
        this.customIcons.update(icons => ({
            ...icons,
            [appId]: iconDataUrl
        }));
    }
    resetCustomIcon(appId) {
        this.customIcons.update(icons => {
            const newIcons = { ...icons };
            delete newIcons[appId];
            return newIcons;
        });
    }
};
exports.IconService = IconService;
exports.IconService = IconService = __decorate([
    (0, core_1.Injectable)({ providedIn: 'root' }),
    __metadata("design:paramtypes", [])
], IconService);
